// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2IPPS","content":"RecentSearches_content__2L6vs"};